(function () {

  var element = document.querySelectorAll('.js-scroll-show')
  if(!element) return

  for(var i=0;i<element.length;i++) {
    setScroll(element[i])
  }

  function setScroll(target) {

    function scroll() {
      var windowH = window.innerHeight

      var elemY = target.getBoundingClientRect().top
      if(elemY < windowH) {
        target.classList.add('is-show')
        window.removeEventListener('scroll', scroll)
      }
    }
    
    window.addEventListener('scroll', scroll)
    scroll()
  }
  

}());